import React from 'react';

export const Container = ({ children, className = '', ...props }) => {
  return (
    <div 
      className={`container mx-auto px-4 sm:px-6 lg:px-8 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export const Row = ({ children, className = '', ...props }) => {
  return (
    <div 
      className={`flex flex-wrap -mx-4 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export const Col = ({ children, className = '', ...props }) => {
  return (
    <div 
      className={`px-4 w-full ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default {
  Container,
  Row,
  Col
}; 